/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCardDTO
 */
export interface UpdateCardDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateCardDTO
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardDTO
     */
    cardSystemId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardDTO
     */
    cardId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardDTO
     */
    cardTypeId?: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateCardDTO
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateCardDTO
     */
    endDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateCardDTO
     */
    preliminaryCardDate?: Date;
}

export function UpdateCardDTOFromJSON(json: any): UpdateCardDTO {
    return UpdateCardDTOFromJSONTyped(json, false);
}

export function UpdateCardDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCardDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'cardSystemId': !exists(json, 'cardSystemId') ? undefined : json['cardSystemId'],
        'cardId': !exists(json, 'cardId') ? undefined : json['cardId'],
        'cardTypeId': !exists(json, 'cardTypeId') ? undefined : json['cardTypeId'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'preliminaryCardDate': !exists(json, 'preliminaryCardDate') ? undefined : (new Date(json['preliminaryCardDate'])),
    };
}

export function UpdateCardDTOToJSON(value?: UpdateCardDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'carePrincipalId': value.carePrincipalId,
        'cardSystemId': value.cardSystemId,
        'cardId': value.cardId,
        'cardTypeId': value.cardTypeId,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString().substr(0,10)),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString().substr(0,10)),
        'preliminaryCardDate': value.preliminaryCardDate === undefined ? undefined : (value.preliminaryCardDate.toISOString().substr(0,10)),
    };
}

